import PropTypes from '@root/vendor/prop-types';
import { Helmet } from '@root/website-tooling/react-helmet';

export default function Seo({
  lang = 'en',
  canonical,
  noIndex = false,
  description,
  title,
  imageURL,
}) {
  const metaImage = buildMetaImageUrl(imageURL, canonical);

  const meta = [
    {
      name: 'description',
      content: description,
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
    {
      name: 'twitter:image',
      content: metaImage,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:image',
      content: metaImage,
    },
    {
      property: 'og:url',
      content: canonical,
    },
  ];

  if (noIndex) {
    meta.push({
      name: 'robots',
      content: 'noindex',
    });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
        {
          rel: 'canonical',
          href: canonical,
        },
      ]}
      meta={meta}
      title={title}
      titleTemplate={'%s'}
    />
  );
}

Seo.propTypes = {
  canonical: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageURL: PropTypes.string,
  lang: PropTypes.string,
  noIndex: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

function buildMetaImageUrl(url, canonical) {
  if (!url) { return ''; }

  const isSourcedFromContentful = url.startsWith('//');
  const isSourcedFromMonorepo = url.startsWith('/static');

  if (isSourcedFromContentful) {
    return `https:${url}`;
  }

  if (isSourcedFromMonorepo && canonical) {
    const origin = new URL(canonical).origin;
    return `${origin}${url}`;
  }

  return url;
}
